<div class="list-data flex flex-col gap-3" [ngClass]="blockClass()" (click)="openListItemsDialog()" role="button">
    <div class="flex flex-col gap-2">
        <div class="flex justify-between items-start">
            <div class="flex items-center gap-2 min-w-0 flex-1">
                <!-- User avatar (if shared list) -->
                <app-me-user-avatar [uid]="listData().uid" size="small"
                    *ngIf="listData().uid !== cc.user.uid"></app-me-user-avatar>
                <!-- Public indicator -->
                <app-public-indicator *ngIf="listData().isPublic" class="inline-flex"></app-public-indicator>
                <!-- Favorite indicator (before title) -->
                <app-favorite-indicator *ngIf="isFav()" class="inline-flex"></app-favorite-indicator>
                <!-- Title -->
                <p class="text-16-400 color-8 mb-0">{{ listData().title }}</p>
            </div>
            <!-- Relative time -->
            <span class="text-12-400 color-7 whitespace-nowrap shrink-0">{{ (listData().localUpdatedAt ?? '') | smartTimeDiff:undefined:'short-weeks' }}</span>
        </div>
        <p class="text-12-400 color-7 mb-0"
            [ngClass]="{'!hidden': !show().includes('description') || !listData().description}"> {{ listData().description
            }}</p>
    </div>
    <div class="flex flex-wrap gap-3"
        [ngClass]="{'!hidden': !show().includes('itemCount') && !show().includes('collaboratorsCount') && !show().includes('access')}">
        <div class="inline-flex items-center gap-1.5" [ngClass]="{'!hidden': !show().includes('itemCount')}">
            <app-svg name="circleCheck" [color]="ss.theme().color7"
                width="12" height="12"></app-svg>
            <span class="text-12-400 color-7">{{ getCompletedRange(listData().listItems || {}) }}</span>
        </div>
        <div class="inline-flex items-center gap-1.5"
            [ngClass]="{'!hidden': !show().includes('collaboratorsCount') || collabCount() === 0}">
            <app-svg name="users" [color]="ss.theme().color7" width="14" height="14"></app-svg>
            <span class="text-12-400 color-7">{{ collabCount() > 10 ? '10+' : collabCount() }}</span>
        </div>
        <div class="inline-flex items-center gap-1.5"
            [ngClass]="{'!hidden': !show().includes('access') || role() === 'owner'}">
            <app-svg [name]="role() === 'editor' ? 'edit' : 'view'" [color]="ss.theme().color7" width="12" height="12"></app-svg>
            <span class="text-12-400 color-7">{{ roleMap()[role() || 'viewer']
                }}</span>
        </div>
    </div>
    <p class="text-12-400 color-7 hashtags-block"
        [ngClass]="{'!hidden': !show().includes('hashtag') || ss.getValidHashtags(listData().hashtags).length === 0 || role() !== 'owner'}">
        <span class="hashtag"
            *ngFor="let tagId of ss.getValidHashtags(listData().hashtags)">#{{ss.tagMap()[tagId]}}</span>
    </p>
</div>